import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Icon from '../../components/common/Icon';
import Loading from '../../components/common/Loading';
import Title from '../../components/common/Title';
import { apiRequest } from '../../utils';
import './Sales.css';

/* The other half of creating tasks: seeing them.

   Without this the follow-ups a rep leaves behind in a doorway are write-only from
   the phone — they exist, in a back office they cannot open. Same rows Machina's
   task manager shows, filtered to this rep and this unit, tickable from the car. */
const SalesTasks = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buId, setBuId] = useState(null);
  const [denied, setDenied] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const ctx = await apiRequest('GET', '/sales/context');
        setBuId(ctx.business_unit_id);
        const data = await apiRequest('GET', `/sales/tasks?bu_id=${ctx.business_unit_id}`);
        setTasks(data.tasks || []);
      } catch {
        setDenied(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const complete = async (task) => {
    // Optimistic: the row leaves the list at once. On failure it comes back, so a
    // task is never silently lost — which matters more here than a spinner would.
    setTasks((prev) => prev.filter((x) => x.id !== task.id));
    try {
      await apiRequest('POST', `/sales/task/${task.id}/status`,
                       { bu_id: buId, status: 'done' });
    } catch {
      setTasks((prev) => [task, ...prev]);
    }
  };

  if (loading) return <Base activeNav="feed"><Loading /></Base>;

  return (
    <Base activeNav="feed">
      <Title>{t('salesMyTasks')}</Title>
      <Card>
        {denied && <p className="sales-hint">{t('salesNoAccess')}</p>}
        {!denied && !tasks.length && <p className="sales-hint">{t('salesNoTasks')}</p>}
        {tasks.map((task) => (
          <div key={task.id} className={`sales-task sales-task--row ${task.is_late ? 'is-late' : ''}`}>
            <button type="button" className="sales-tick" onClick={() => complete(task)}
                    aria-label={t('salesMarkDone')}>
              <Icon name="check" />
            </button>
            <div
              className="sales-task__main"
              onClick={() => task.context_type === 'company' && task.context_id
                && navigate(`/sales/company/${task.context_id}`)}
            >
              <span className="sales-result__name">{task.title}</span>
              <span className="sales-result__sub">
                {[task.context_label, task.due_at ? task.due_at.slice(0, 10) : null]
                  .filter(Boolean).join(' · ')}
              </span>
            </div>
          </div>
        ))}
      </Card>
    </Base>
  );
};

export default SalesTasks;
